import styled from "@mui/material/styles/styled"
import React from "react"
import ReactDOM from "react-dom"

import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Navigation, Keyboard } from "swiper/modules"

import Box from "@mui/material/Box"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"
import "./styles.css"

const ModalBackdrop = styled(Box)(
  ({ theme }) => `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 1;

  ${theme.breakpoints.up("sm")} {
    display: none;
  }
`
)

const ModalBox = styled(Box)(
  ({ theme }) => `
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  height: 100vh;

  background-color: ${theme.palette.background.default};
  width: 100%;

  ${theme.breakpoints.up("sm")} {
    display: none;
  }
`
)

export const Onboarding = ({ slides }) => {
  return ReactDOM.createPortal(
    <ModalBackdrop>
      <ModalBox>
        <Swiper
          pagination={{
            clickable: true,
          }}
          modules={[Keyboard, Pagination, Navigation]}
          keyboard={{
            enabled: true,
          }}
          className="mySwiper"
        >
          {slides.map((slide, i) => {
            return <SwiperSlide key={i}>{slide.component} </SwiperSlide>
          })}
        </Swiper>
      </ModalBox>
    </ModalBackdrop>,
    document.querySelector("#root")
  )
}
